let alreadyAddedStripeToHead = false;

/** Dynamically adds the Stripe pricing table script to the page (only inserted once). */
function addStripeToHead(): void {
    if (!alreadyAddedStripeToHead) {
        const script = document.createElement("script");

        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.async = true;

        document.body.appendChild(script);
        alreadyAddedStripeToHead = true;
    }
}

/** URL paths for each Stripe pricing table type. */
const stripePriceTables: Record<'GROUP_ANNUAL' | 'INDIVIDUAL' | 'ACADEMIC' | 'CORPORATE', string> = {
    GROUP_ANNUAL: 'stripe/annual-group-pricing-table/photo51',
    INDIVIDUAL: 'stripe/annual-individual-pricing-table/photo51',
    ACADEMIC: 'stripe/academic-pricing-table/photo51',
    CORPORATE: 'stripe/corporate-pricing-table/photo51',
};

type StripeObjectType = 'group' | 'user';

/**
 * Builds a Stripe client reference ID compatible with the backend's ClientReferenceId class.
 *
 * @param objectType - The type of object ('group' or 'user').
 * @param id - The object's ID.
 */
function buildClientReferenceId(objectType: StripeObjectType, id: number | string): string | undefined {
    switch (objectType) {
        case 'group': return `group_${id}`;
        case 'user': return `user_${id}`;
        default: return undefined;
    }
}

export {
    addStripeToHead,
    stripePriceTables,
    buildClientReferenceId,
}
